import { useEffect, useRef } from 'react';

interface TrustBoxProps {
  templateId: string;
  businessunitId: string;
  locale?: string;
  styleHeight?: string;
  styleWidth?: string;
  token?: string;
}

const TrustBox: React.FC<TrustBoxProps> = ({
  templateId,
  businessunitId,
  locale = "en-US",
  styleHeight = "52px",
  styleWidth = "100%",
  token
}) => {
  const trustBoxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Check if Trustpilot widget script is already loaded
    if (window.Trustpilot) {
      // If script is loaded, reinitialize the widget
      if (trustBoxRef.current) {
        window.Trustpilot.loadFromElement(trustBoxRef.current);
      }
    } else {
      // If script is not loaded, create and append it
      const script = document.createElement('script');
      script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.async = true;
      script.type = 'text/javascript';
      
      script.onload = () => {
        // Once script is loaded, initialize the widget
        if (trustBoxRef.current && window.Trustpilot) {
          window.Trustpilot.loadFromElement(trustBoxRef.current);
        }
      };
      
      document.head.appendChild(script);
    }
  }, [templateId, businessunitId, locale, styleHeight, styleWidth, token]);

  return (
    <div
      ref={trustBoxRef}
      className="trustpilot-widget"
      data-locale={locale}
      data-template-id={templateId}
      data-businessunit-id={businessunitId}
      data-style-height={styleHeight}
      data-style-width={styleWidth}
      data-theme="light"
      {...(token && { 'data-token': token })}
    >
      <a
        href={`https://www.trustpilot.com/review/thequickassist.co`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};

// Add TypeScript declaration for the global Trustpilot object
declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: HTMLElement) => void;
    };
  }
}

export default TrustBox;
